export default __webpack_public_path__ + "static/api-first-architettura-sistemi-flessibili-0c144f851b6556901f3bd49ffe54203d.jpg";